import { useRef } from 'react'

import PanelRow from '@/components/sections/home/PanelRow'
import Container from '@/components/ui/Container'
import Eyebrow from '@/components/ui/Eyebrow'
import { useData } from '@/hooks/useLocale'
import { useScrollProgress } from '@/hooks/useScrollProgress'

// The rail fills as the list passes a line 55% down the screen.
const railProgress = (el) => {
  const rect = el.getBoundingClientRect()
  return (window.innerHeight * 0.55 - rect.top) / Math.max(1, rect.height)
}

/**
 * The four panels, one row each (design: Home, Panels), with a rail beside
 * them that fills blue as you scroll through.
 */
export default function PanelsSection() {
  const { PANELS } = useData()
  const list = useRef(null)
  const fill = useScrollProgress(list, railProgress)

  return (
    <Container
      as="section"
      id="panels"
      className="flex flex-col gap-11 overflow-x-clip py-[clamp(64px,9vw,110px)]"
    >
      <div className="flex flex-col gap-2.5">
        <Eyebrow className="text-subtle">{PANELS.eyebrow}</Eyebrow>
        <h2 className="text-[clamp(32px,3.6vw,46px)] tracking-[-0.025em]">
          {PANELS.title}
        </h2>
        <span className="text-sm text-subtle">{PANELS.text}</span>
      </div>

      <div ref={list} className="relative flex flex-col gap-20 sm:ps-14">
        <div
          aria-hidden="true"
          className="absolute start-0 top-0 bottom-0 hidden w-0.5 rounded-[1px] bg-line sm:block"
        >
          <span
            className="absolute start-0 top-0 w-0.5 rounded-[1px] bg-brand"
            style={{ height: `${fill * 100}%` }}
          />
        </div>
        {PANELS.items.map((panel, i) => (
          <PanelRow key={panel.title} panel={panel} n={i + 1} />
        ))}
      </div>
    </Container>
  )
}
